import PubSub from "pubsub-js";
import Slick from "slick-carousel";
import loadTouchEvents from 'jquery-touch-events';
loadTouchEvents($);

var HeroBgImageSlider = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-HeroBgImageSlider',
	};

	$.extend(true, this.options, options);

};

HeroBgImageSlider.prototype.init = function() {

	var self = this;

	// sliders
	this.$imageSlider = this.options.$el.find(`.${self.options.baseClass}__imageBackgroundSlider`);
	this.$textSlider = this.options.$el.find(`.${self.options.baseClass}__textSlider`);

	// initialize image slider
	this.$imageSlider.slick({
		arrows: false,
		fade: true,
		speed: 750,
		asNavFor: self.$textSlider[0],
		swipe: false,
	});

	// initialize text slider
	this.$textSlider.slick({
		arrows: false,
		fade: true,
		speed: 200,
		asNavFor: self.$imageSlider[0],
		swipe: false,
	});

	// right side text
	this.positionRightSideText();

	$(window).on('load', function() {
		self.positionRightSideText();
	});

	PubSub.subscribe("resized", function(){
		self.positionRightSideText();
	});

	// next image button
	this.options.$el.find(`.${self.options.baseClass}__nextImage`).on('click', function() {

		//self.$imageSlider.slick('slickNext');
		self.$textSlider.slick('slickNext');

		self.startAutoplay();

	});

	// kick off autoplay
	this.startAutoplay();

	// swipe events
	this.options.$el.on('swiperight', function() {
		self.startAutoplay();
		self.$textSlider.slick('slickPrev');
	});

	this.options.$el.on('swipeleft', function() {
		self.startAutoplay();
		self.$textSlider.slick('slickNext');
	});

};

HeroBgImageSlider.prototype.startAutoplay = function() {

	var self = this;

	this.autoplayInterval;

	window.clearInterval(self.autoplayInterval);

	this.autoplayInterval = window.setInterval(function() {
		self.$textSlider.slick('slickNext');
	}, 8000);

};

HeroBgImageSlider.prototype.positionRightSideText = function() {

	var self = this;

	var $rightSideText = this.options.$el.find(`.${self.options.baseClass}__rightSideText`);
	var $contentWrapper = this.options.$el;

	var rightSideTextHeight = $rightSideText.outerWidth(); // element is rotated via css so width is actually height
	var rightSideTextWidth = $rightSideText.outerHeight(); // element is rotated via css so height is actually width

	var contentWrapperHeight = $contentWrapper.outerHeight();
	var contentWrapperWidth = $contentWrapper.width();

	// top
	var newTop = (contentWrapperHeight / 2) - (rightSideTextHeight / 2);
	$rightSideText.css('top', newTop);

	// right
	// pull right by negative height to align with right edge, then move away by 4% width
	// pulling right by negative height aligns with right edge because we're using transform-origin: 0px 0px
	// which means we pull right by negative height (which is width before our transform), and then
	// we swing the item down 90 degrees by it's top left edge
	var newRight = (rightSideTextHeight * -1) + (contentWrapperWidth * 0.04); 
	$rightSideText.css('right', newRight);

};

export default HeroBgImageSlider;
